<app-dialog-container (onClose)="closeDialog()">
    <div class="flex flex-col gap-4 md:px-0 sm:px-6">
        <form [formGroup]="referForm" *ngIf="!submitted">
            <div class="md:max-h-[50vh] max-h-[80vh] overflow-y-auto">
                <h1 class="text-2xl font-bold text-black space-y-8 sm:space-y-6 mb-4" i18n>Refer Someone</h1>
                <p *ngIf="error" class="block text-red-500 font-medium leading-6 my-4">
                    Sorry, there was an issue creating your referral code. Please try again shortly.
                </p>
                <p class="block font-medium leading-6 my-4" i18n>
                    Refer someone you know for this job today, and help them find their next big move.<span
                        *ngIf="job.bounty">
                        If you're successful, you could be eligible for the following reward: {{ job.bounty }}</span
                    >
                </p>
                <div class="flex flex-col gap-4">
                    <div class="grow" formGroupName="creator">
                        <label for="firstName" class="block text-sm font-medium leading-6" i18n>Your Name<sup>*</sup></label>
                        <input
                            formControlName="name"
                            placeholder="Your Name"
                            required
                            class="block w-full rounded-md border-0 p-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                        <div
                            *ngIf="
                                !referForm.get('creator.name').pristine &&
                                referForm.get('creator.name').hasError('required')
                            "
                            class="text-red-500 text-sm mt-1"
                            i18n>
                            You must enter your name.
                        </div>
                    </div>

                    <div class="grow" formGroupName="creator">
                        <label for="email" class="block text-sm font-medium leading-6" i18n>Email Address<sup>*</sup></label>
                        <input
                            formControlName="email"
                            placeholder="Email Address"
                            required
                            class="block w-full rounded-md border-0 p-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                        <div
                            *ngIf="
                                !referForm.get('creator.email').pristine &&
                                referForm.get('creator.email').hasError('required')
                            "
                            class="text-red-500 text-sm mt-1"
                            i18n>
                            You must enter your email address.
                        </div>
                        <div
                            *ngIf="
                                !referForm.get('creator.email').pristine &&
                                !referForm.get('creator.email').hasError('required') &&
                                referForm.get('creator.email').hasError('email')
                            "
                            class="text-red-500 text-sm mt-1"
                            i18n>
                            You must enter a valid email address.
                        </div>
                    </div>

                    <div class="grow">
                        <label for="referees" class="block text-sm font-medium leading-6" i18n
                            >Who would you like to refer for this job?</label
                        >
                        <input
                            formControlName="referees"
                            placeholder="Please enter their email address."
                            required
                            i18n
                            class="block w-full rounded-md border-0 p-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                </div>
            </div>
            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-2">
                <button
                    class="inline-flex items-center cursor-pointer disabled:bg-blue-300 disabled:text-white/50 disabled:cursor-not-allowed"
                    [ngClass]="applyButtonClasses"
                    [disabled]="submitting || referForm.invalid"
                    (click)="apply()"
                    i18n>
                    <svg
                        *ngIf="submitting"
                        class="animate-spin -ml-1 mr-1 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24">
                        <circle
                            class="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"></circle>
                        <path
                            class="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Refer Someone
                </button>
            </div>
        </form>
        <div *ngIf="submitted">
            <h1 class="text-2xl font-bold text-black space-y-8 sm:space-y-6" i18n>Referral Sent</h1>
            <p class="block text-sm font-medium leading-6 text-gray-500 mb-4" i18n>
                Thanks! Your nominated referees have been sent an email. You can also <a href="#" (click)="copyToClipboard(referral.code); $event.stopPropagation();">click
                    here</a> to copy a link to this job to share with your unique referral code.
            </p>
        </div>
    </div>
</app-dialog-container>
